import script from "./GstFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./GstFeatures.vue?vue&type=script&setup=true&lang=js"

import "./GstFeatures.vue?vue&type=style&index=0&id=3cb34f9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cb34f9b"]])

export default __exports__